module.exports = __webpack_public_path__ + "img/Other1.612e89ed.svg";